<section class="public registration">
  <div class="lg-container m-auto flex h-full w-full flex-col">
    <div class="pt-8 max-mobile:pt-5">
      <img class="mx-auto block" ngSrc="/images/header/public-logo.svg" alt="Match15" width="177" height="38" priority>
    </div>
    <div class="grid flex-1 place-items-center px-2 py-8 max-mobile:px-4">
      <div
        [class.grid-cols-\[1fr_max-content\]]="showBanners"
        [class.grid-cols-1]="!showBanners"
        class="grid items-center justify-items-center w-full gap-x-7.5 max-mobile:flex max-mobile:flex-col max-mobile:items-center max-mobile:justify-center max-mobile:gap-y-6"
      >
        <div class="w-96.25 max-mobile:flex max-mobile:w-full max-mobile:flex-1 max-mobile:flex-col max-mobile:justify-center">
          <main class="public__content">
            <router-outlet />
          </main>
        </div>
        @if (showBanners) {
          <div class="max-mobile:w-full max-mobile:mt-auto max-md:hidden">
            <bingo-welcome-slider class="block w-102.25 max-mobile:w-full" />
          </div>
        }
      </div>
    </div>
  </div>
  <bingo-public-footer />
</section>
